import { Routes } from '@angular/router';
import { ArticleLibraryComponent } from './article-library/article-library.component';
import { ExportsComponent } from './exports/exports.component';
import { SharedExportsComponent } from './shared-exports/shared-exports.component';
import { UserManagementComponent } from './admin/user-management/user-management.component';
import { OrganizationManagementComponent } from './admin/organization-management/organization-management.component';
import { LoginScreenComponent } from './login-screen/login-screen.component';
import { AppContentComponent } from './app-content/app-content.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
	// Login route (no guard needed)
	{
		path: 'login',
		component: LoginScreenComponent,
		data: { animation: 'login' },
	},

	// Default route - redirect to login
	{ path: '', redirectTo: '/login', pathMatch: 'full' },

	// App content wrapper with nested protected routes
	{
		path: '',
		component: AppContentComponent,
		canActivate: [authGuard],
		data: { animation: 'app-content' },
		children: [
			{
				path: 'article-library',
				component: ArticleLibraryComponent,
				data: { animation: 1 },
			},
			{
				path: 'exports',
				component: ExportsComponent,
				data: { animation: 2 },
			},
			// {
			// 	path: 'shared',
			// 	component: SharedExportsComponent,
			// 	data: { animation: 3 },
			// },
			{
				path: 'admin/users',
				component: UserManagementComponent,
				data: { animation: 4 },
			},
			{
				path: 'admin/organizations',
				component: OrganizationManagementComponent,
				data: { animation: 5 },
			},
		],
	},
];
